import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconePin extends Component {
    render() {
        return (
            <SvgIcon
                baseProfile="tiny"
                height="24"
                version="1.2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                style={{ fill: this.props.color }}
            >
                <path d="M16.729 4.271c-.389-.391-1.021-.393-1.414-.004-.104.104-.176.227-.225.355-.832 1.736-1.748 2.715-2.904 3.293C10.889 8.555 9.4 9 7 9c-.13 0-.26.025-.382.076-.245.102-.439.297-.541.541-.101.244-.101.52 0 .764.051.123.124.234.217.326l3.243 3.243L5 20l6.05-4.537 3.242 3.242c.092.094.203.166.326.217.122.051.252.078.382.078s.26-.027.382-.078c.245-.102.44-.295.541-.541.051-.121.077-.252.077-.381 0-2.4.444-3.889 1.083-5.166.577-1.156 1.556-2.072 3.293-2.904.129-.049.251-.121.354-.225.389-.393.387-1.025-.004-1.414l-3.997-4.02z" />
            </SvgIcon>
        );
    }
}

IconePin.propTypes = {
    color: PropTypes.string
};

IconePin.defaultProps = {
    color: '#000000'
};

export default IconePin;
